import { useSuspenseQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute, linkOptions } from '@tanstack/react-router'
import { FileWarningIcon, FolderIcon, InfoIcon, ShieldIcon } from 'lucide-react'

import { queryCompanyGet } from '@api/company/company.queries'

import SwitchViewTabs from '../-components/switch-view-tabs'
import DebtorCompanyStats from './-components/debtor-company-stats/debtor-company-stats'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/debtor',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { uuid } = Route.useParams()
  const company = useSuspenseQuery(queryCompanyGet(uuid))

  const routesData = [
    subRoutes['.'],
    { ...subRoutes.coverages, count: company.data.stats.debtorCoveragesCount },
    {
      ...subRoutes.insistences,
      count: company.data.stats.debtorInsistencesCount,
    },
    subRoutes.files,
  ]

  return (
    <>
      <DebtorCompanyStats companyUuid={uuid} />
      <div className="flex w-full flex-1 flex-col overflow-hidden">
        <SwitchViewTabs routes={routesData} />
        <div className="flex w-full flex-1 overflow-y-auto p-6">
          <Outlet />
        </div>
      </div>
    </>
  )
}

const subRoutes = {
  '.': {
    name: '.',
    icon: InfoIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/debtor',
    }),
    displayName: 'data.companies.uuid.debtor.tabs.information',
  },
  coverages: {
    name: 'coverages',
    icon: ShieldIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/debtor/coverages',
    }),
    displayName: 'data.companies.uuid.debtor.tabs.coverages',
  },
  insistences: {
    name: 'insistences',
    icon: FileWarningIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/debtor/insistences',
    }),
    displayName: 'data.companies.uuid.debtor.tabs.insistences',
  },
  files: {
    name: 'files',
    icon: FolderIcon,
    link: linkOptions({
      from: Route.fullPath,
      to: '/app/data/companies/$uuid/debtor/files',
    }),
    displayName: 'data.companies.uuid.debtor.tabs.files',
  },
} as const
